import React from 'react';

interface HandDrawnCircleProps {
  readonly number: number;
  readonly className?: string;
  readonly variant?: 'default' | 'white' | 'dark';
}

export function HandDrawnCircle({ number, className = '', variant = 'default' }: Readonly<HandDrawnCircleProps>): React.ReactElement {
  const bgColors = {
    default: 'rgba(166, 94, 61, 1)', // burnt-sienna
    white: 'rgba(255, 255, 255, 1)',
    dark: 'rgba(64, 60, 56, 1)' // charcoal
  };

  const textColors = {
    default: 'text-white',
    white: 'text-burnt-sienna',
    dark: 'text-white'
  };

  return (
    <div className={`relative w-12 h-12 inline-block ${className}`}>
      <svg
        className="absolute inset-0 w-full h-full -rotate-1"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="24"
          cy="24"
          r="22"
          stroke={bgColors[variant]}
          strokeWidth="1.5"
          strokeOpacity="0.3"
          fill={bgColors[variant]}
        />
      </svg>
      <span className={`absolute inset-0 flex items-center justify-center font-mono font-bold text-lg ${textColors[variant]}`}>
        {number}
      </span>
    </div>
  );
}
